import typeToReducer from 'type-to-reducer';

const initialState = {
};
export default typeToReducer({
}, initialState);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Login/screens/IdentifyActivation/reducers/index.js
 **/